import React from 'react';
import styled from 'styled-components';
import {
    Carousel as MaestroCarousel,
    NavigationElementPosition,
    spacing,
} from '@landr/maestro';
import { useMilestonesController } from 'controllers/business/Milestones/Milestones.controller';
import { useSamplePlayerContext } from 'contexts/SamplePlayerContext/SamplePlayerContext';
import useHeroCarousel from './hooks/useHeroCarousel';
import HeroCarouselProvider, {
    useHeroCarouselContext,
} from './context/HeroCarouselContext';

const FullHeightCarousel = styled(MaestroCarousel)`
    max-height: 100%;
    height: 100%;

    > div:first-child {
        height: 100%;
    }

    /* @maestro-no-props */
    > div > div[direction='horizontal'] {
        position: relative;
        bottom: ${spacing('xxl')};
    }
`;

const _HeroCarousel = ({
    slides,
    dotPosition,
    autoNavigationDelay,
    handleNavigate,
}: {
    slides: JSX.Element[];
    dotPosition?: NavigationElementPosition;
    autoNavigationDelay?: number;
    handleNavigate: () => void;
}) => {
    return (
        <FullHeightCarousel
            items={slides}
            slidesPerPage={{
                default: 1,
            }}
            scrollToSelection={true}
            gutter={0}
            dotPosition={dotPosition}
            hideArrows={true}
            autoNavigationDelay={autoNavigationDelay}
            onNavigate={handleNavigate}
            lazyloading={true}
        />
    );
};

const HeroCarousel = () => {
    const { get } = useMilestonesController();
    const { isAutoPlayAuthorized, enableAutoPlay } = useHeroCarouselContext();

    const { stopActiveSamplePlayer, getActivePlayerId } =
        useSamplePlayerContext();
    const { slides, dotPosition, autoNavigationDelay, handleNavigate } =
        useHeroCarousel({
            get,
            isAutoPlayAuthorized,
            enableAutoPlay,
            stopActiveSamplePlayer,
            getActivePlayerId,
        });

    return (
        <_HeroCarousel
            slides={slides}
            dotPosition={dotPosition}
            autoNavigationDelay={autoNavigationDelay}
            handleNavigate={handleNavigate}
        />
    );
};

const HeroCarouselWithContext = () => {
    return (
        <HeroCarouselProvider>
            <HeroCarousel />
        </HeroCarouselProvider>
    );
};

export default HeroCarouselWithContext;
